import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { confirmModal } from '@/components/ui/modal'
import { removeBlock } from '../lib/surumMutations'
import type { SablonSurum } from '../types'

export function useRemoveBlock(surum: SablonSurum, onChange: (next: SablonSurum) => void, onRemoved?: (next: SablonSurum) => void) {
  const { t } = useTranslation()

  return async (blockId: string) => {
    const block = Object.values(surum.blocksBySection).flat().find((b) => b.id === blockId)
    if (!block) return
    const field = block.kind === 'field' || block.kind === 'signature' ? surum.fields.find((f) => f.id === block.fieldId) : undefined
    const ok = await confirmModal({
      title: t(field ? 'hr.belgeler.remove.fieldTitle' : 'hr.belgeler.remove.blockTitle'),
      description: field ? t('hr.belgeler.remove.fieldBody', { name: field.label }) : t('hr.belgeler.remove.blockBody'),
      confirmLabel: t('hr.belgeler.remove.confirm'),
      destructive: true,
    })
    if (!ok) return
    const next = removeBlock(surum, blockId)
    onChange(next)
    onRemoved?.(next)
    toast.success(t(field ? 'hr.belgeler.remove.fieldDone' : 'hr.belgeler.remove.blockDone'))
  }
}
